import React, { useEffect, useState } from 'react';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';

import '../../wdyr';
import AppConfig from '../../config/app-config';
import { AuthProvider } from '../../hooks/useAuth/auth-provider';
import useSessionState from '../../hooks/useSessionState/useSessionState';
import { SessionStateKeys } from '../../models/session-state-keys';
import { DragNDropProvider } from '../../hooks/useDragNDropContext/drag-n-drop-provider';
import AppView from './app-view';

function AppProvider() {
  const [isAuthenticated, setIsAuthenticated] = useSessionState(
    {
      initialState: false,
      key: SessionStateKeys.IsAuthenticated,
    },
  );

  const selectedTheme = AppConfig.SelectedCustomer;

  const enableAnimations = AppConfig.EnableAnimations;

  const [isSplashPage, setIsSplashPage] = useState<boolean>(false);

  useEffect(() => {
    if (selectedTheme === 'lower' || selectedTheme === 'lwr') {
      setIsSplashPage(true);
    }
  }, [selectedTheme]);

  return (
    <RecoilRoot>
      {/* @ts-expect-error Allowing this since I'm sure finishButton is used all over the place */}
      <ThemeProvider theme={AppConfig.Theme}>
        <AuthProvider
          value={isAuthenticated}
          setValue={setIsAuthenticated}
        >
          <DragNDropProvider>
            <AppView
              isSplashPage={isSplashPage}
              enableAnimations={enableAnimations}
            />
          </DragNDropProvider>
        </AuthProvider>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default AppProvider;
